import React from "react";
import ReactDOM from "react-dom/client";
import singleSpaReact from "single-spa-react";
import EditorPicksComponent from "./root.component.js";

function domElementGetter() {
  return document.getElementById("editorPicks");
}

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: EditorPicksComponent,
  domElementGetter,
  renderType: "createRoot"
});

export const bootstrap = [reactLifecycles.bootstrap];
export const unmount = [reactLifecycles.unmount];

export function mount(props) {
  return reactLifecycles.mount(props);
}
